export const followLinkAttribute = function (el, event) {
    const url = el.getAttribute("data-link");
    if (!event.target.closest(".article__button__favorite")) {
        window.location.href = url;
    }
};
